import { useEffect, useRef, useState } from 'react';
import { Avatar, AvatarFallback } from '@/components/shadcn-ui/avatar';
import { ScrollArea } from '@/components/shadcn-ui/scroll-area';
import { ChevronDown, ChevronUp } from 'lucide-react';

export function AdminChatHistory({ chatHistory }) {
  const scrollRef = useRef(null);
  const bottomRef = useRef(null);

  // Sort messages by createdAt timestamp (oldest first)
  const sortedMessages = chatHistory
    ? [...chatHistory].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    : [];

  useEffect(() => {
    // Auto-scroll to bottom when component mounts
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };


  return (
    <div ref={scrollRef} className="space-y-4 pb-4">
      {sortedMessages.length === 0 ? (
        <div className="flex items-center justify-center min-h-[200px] text-gray-400">
          No chat history available
        </div>
      ) : (
        <>
          {sortedMessages.map((message) => (
            <div key={message._id} className="flex flex-col gap-2">
              <div className={`flex gap-3 ${message.sender === 'user' ? 'flex-row' : 'flex-row-reverse'}`}>
                {/* Avatar */}
                {message.sender === 'ai' ? (
                  <Avatar className="size-10 bg-black flex-shrink-0">
                    <AvatarFallback>
                      <img src="/kelly.png" alt="AI Assistant" className="size-10 object-cover bg-black" />
                    </AvatarFallback>
                  </Avatar>
                ) : (
                  <Avatar className=" dark size-10 bg-background-secondary flex-shrink-0">
                    <AvatarFallback className="dark bg-background-secondary text-white text-sm font-medium">
                      U
                    </AvatarFallback>
                  </Avatar>
                )}

                {/* Message Content */}
                <div className="flex flex-col gap-1 max-w-[80%]">
                  <div
                    className={`rounded-lg p-3 ${message.sender === 'user'
                      ? 'dark bg-secondary/90 text-white'
                      : 'text-white bg-neutral-800'
                      }`}
                  >
                    <p className="text-sm whitespace-pre-wrap">{message.message}</p>

                    {/* Show metadata badge if present and done is true */}
                    {message.done && message.metadata && Object.keys(message.metadata).length > 0 && (
                      <div className="mt-2 pt-2 border-t border-gray-600">
                        <p
                          className="flex items-center gap-2 text-xs text-gray-300 hover:text-white transition-colors"
                        >
                          <span>✓ Form Completed </span>

                        </p>


                      </div>
                    )}
                  </div>

                  {/* Timestamp */}
                  <span className={`text-xs text-gray-400 ${message.sender === 'user' ? 'text-left' : 'text-right'}`}>
                    {formatTimestamp(message.createdAt)}
                  </span>
                </div>
              </div>
            </div>
          ))}
          <div ref={bottomRef} />
        </>
      )}
    </div>
  );
}

